import { portalStoreToken } from '@servicetitan/cp-ui';
import { useDependencies } from '@servicetitan/react-ioc';
import { FC, useRef } from 'react';
import { PortalAuthStore } from '../../../auth/stores/portal-auth.store';
import { WebPortalStore } from '../../stores/portal.store';
import { useLogoVersion } from './logo-helper';

interface PortalLogoProps {
    className?: string;
}

export const PortalLogo: FC<PortalLogoProps> = props => {
    const { className } = props;
    const [{ brand }] = useDependencies<[PortalAuthStore]>(PortalAuthStore);
    const [{ settings }] = useDependencies<[WebPortalStore]>(portalStoreToken as any);
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty brand.logoUrl must fall back to the portal setting, which ?? would not do
    const imageUrl = brand?.logoUrl ? brand.logoUrl : settings?.logo;
    const logoRef = useRef<HTMLImageElement>(null);
    const handleImageLoad = useLogoVersion();

    return (
        <img
            className={className}
            ref={logoRef}
            src={imageUrl}
            alt="Company logo"
            onLoad={() => handleImageLoad(logoRef.current)}
        />
    );
};
